import moment from "moment";
import React,{useEffect} from "react";

import {Switch,Route,Redirect,withRouter, useHistory} from "react-router-dom"
import { CheckValidUser } from "./Utils";
import { socket } from "./common";

const PrivetRoute = ({path,Component}) =>{
  // console.log(token);
  const history=useHistory()
  let token =window.localStorage.getItem("token");
  let logintime =window.localStorage.getItem("login_time");
  let user_info =window.localStorage.getItem("user_info");
  let trust_browser =window.localStorage.getItem("trust_browser");
  const current_time=moment().utcOffset("+05:30")
  const COMPANY_LOGO=window.localStorage.getItem('COMPANY_LOGO')
  const COMPANY_FAVICON=	window.localStorage.getItem('COMPANY_FAVICON')
  const COMPANY_NAME=	window.localStorage.getItem('COMPANY_NAME')
  useEffect(()=>{ 
    const diff_hours=current_time.diff(moment(logintime).utcOffset("+05:30"),'hours')
      console.log('days',trust_browser,current_time.diff(moment(logintime).utcOffset("+05:30"),'hours'))
      // if(trust_browser=='true'){
      if(logintime==NaN||logintime==undefined||diff_hours>=24){
        window.localStorage.setItem('token', '')
        window.localStorage.setItem('user_info', JSON.stringify({}))
        window.localStorage.setItem('login_time','')
        window.localStorage.setItem('trust_browser','')
        history.push('/')
      }
    // }else{
    //   window.onbeforeunload = function() {
    //     window.localStorage.setItem('token', '')
    //     window.localStorage.setItem('user_info', JSON.stringify({}))
    //     window.localStorage.setItem('login_time','')
    //     window.localStorage.setItem('trust_browser','')
    //     history.push('/')
    //   };
    // }
      onHandalCheckValidUses()
      socket.on('CheckLoginUseValid',(massges)=>{
        console.log(massges,JSON.parse(user_info||'{}'));
        if(massges?.UNIQUE_ID==JSON.parse(user_info||'{}')?.UNIQUE_ID){
          onHandalCheckValidUses()
        }
      })
      let link1 = document.querySelector("link[rel~='icon']");
			let title_el = document.querySelector("title");
      if(COMPANY_FAVICON){
        link1.href =COMPANY_FAVICON
        }else{
            link1.href='data:image/png;base64,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'
        }
        if(COMPANY_NAME){
            title_el.innerHTML =COMPANY_NAME
        }else{
            title_el.innerHTML='MEMIGHTY'
        }
    },[])

    const onHandalCheckValidUses=async()=>{
      const data=await CheckValidUser(JSON.parse(user_info||'{}'))
      if(data?.success==true){

      }else if(data?.err?.response?.status===400){
        window.localStorage.setItem('token', '')
        window.localStorage.setItem('user_info', JSON.stringify({}))
        window.localStorage.setItem('login_time','')
        history.push('/')
      }
    }
    return(
      <>
      
    {token&&token!=="" ? <Route  
        path={path}
        component={Component}
        exact
        />
        :
        <Redirect push to="/" />
        }
      </>
    )
  }
  
  export default withRouter(PrivetRoute)